import {
  gasDemandGetData,
  gasDemandInputData
} from '@/api/api'

const state = {
  gasDemandList: []
}

const getters = {
  gasDemandList: state => state.gasDemandList
}

const actions = {
  loadGasDemandList ({ dispatch }, parm) {
    return gasDemandGetData(parm).then((data) => {
      dispatch('setGasDemandList', data)
    })
  },
  gasDemandInputData ({ dispatch }, file) {
    return gasDemandInputData(file)
  },
  setGasDemandList ({ commit }, data) {
    commit('setGasDemandList', data)
  }
}

const mutations = {
  setGasDemandList (state, data) {
    state.gasDemandList = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/gas_demand.js